import { createAction, props } from '@ngrx/store';
import { QueryParams } from 'mbs-ui-shared@models/Paging';
import { BackupHistory } from 'mbs-ui-shared@models/backupHistory';
import { PagingActionTypes } from 'mbs-ui-shared@store/pagingStoreFactory/pagingStoreTypes';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';

const getActionType = (actionType: PagingActionTypes): string => `[${StoreTypes.BackupHistory}] ${actionType}`;

export const loadPage = createAction(
  getActionType(PagingActionTypes.LoadPage),
  props<{ filters?: QueryParams; pageNumber?: number; perPage?: number; isFullRefresh?: boolean }>()
);
export const loadPageSuccess = createAction(
  getActionType(PagingActionTypes.LoadPageSuccess),
  props<{ pageNumber: number; entities: BackupHistory[]; total: number; totalComputers: number }>()
);
export const loadPageError = createAction(getActionType(PagingActionTypes.LoadPageError));
